/**
 * PUWYLO batch NON-presentation SOT tracker (PDE-2806, PDE-2647).
 *
 * Fires a single SOT event through the shared CMS-component dispatch path for any PUWYLO
 * card (Card 1 Keep Shopping, Card 2 Deals, future cards). Hands the tracker a `null`
 * descriptor (renderable card or batch failure) → no-op.
 *
 * The dispatch logic is card-agnostic; the card identity lives in the event descriptor's
 * `sotType` and `sotFields`.
 */

import { sendCmsComponentEvent } from 'analytics/utils/cmsComponents';
import constants from 'constants/content';

const { COMPONENT_TYPES } = constants;

/**
 * Fires exactly one PUWYLO non-presentation SOT event through the shared CMS-component
 * dispatch, or nothing when handed a null descriptor. Card-agnostic — the caller's event
 * descriptor carries the card-specific sotType and sotFields.
 *
 * @param {{ sotType: string, sotFields: object }|null} event descriptor from the builder
 * @param {object} [meta]
 * @param {string} [meta.sid] the PUWYLO slot id
 * @param {string} [meta.title] recap title (or '')
 * @param {number} [meta.publishedVersion] CMS child published version for sotV316
 */
function firePuwyloBatchCardSotEvent(event, { sid, title, publishedVersion } = {}) {
    if (!event) {
        return;
    }

    const item = { ...event.sotFields, sid };

    sendCmsComponentEvent({
        items: [item],
        eventName: event.sotType,
        title,
        sid,
        component: COMPONENT_TYPES.RECAP,
        publishedVersion
    });
}

export { firePuwyloBatchCardSotEvent };
